import { Link } from 'react-router-dom'
import {ArrowLeft} from 'lucide-react'
import Logo from '@/components/Logo'

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center">
      <Logo />
      <p className="mt-8 text-6xl font-bold text-slate-900">404</p>
      <h1 className="mt-2 text-xl font-semibold text-slate-800">Página no encontrada</h1>
      <p className="mt-2 max-w-sm text-sm text-slate-500">
        La página que buscas no existe o fue movida. Verifica la dirección o vuelve al inicio.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
      >
        <ArrowLeft size={16} /> Volver al inicio
      </Link>
    </div>
  )
}

export default NotFound
